import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/core/services/auth.service';
import { StringConstants } from '@app/shared/string-constants';

@Component({
	selector: 'kpa-auto-logout',
	templateUrl: './auto-logout.component.html',
	styleUrl: './auto-logout.component.scss',
})
export class AutoLogoutComponent implements OnInit {
	isloading: boolean = false;
	savingAudit = StringConstants.savingAudit;

	constructor(private authService: AuthService) {}
	ngOnInit(): void {
		this.isloading = true;
		this.logout();
	}
	logout() {
		this.authService.logout();
		window.close();
	}
}
